<template>
  <main-layout>
    <div>
      <v-tabs
        v-model="viewPage"
        color="white"
        :slider-color="$vuetify.theme.primary"
        style="font-size: 18px"
      >
        <v-tab
          v-for="(item, index) in filterdMenuItem"
          :key="`menu-item-${index}`"
          style="text-transform: capitalize"
          ripple
          :href="`#${item.view}`"
          @click="updateSlug(item.view)"
          >{{ item.text }}</v-tab
        >
      </v-tabs>

      <!-- <v-container class="mt-4">  -->
      <Promotions v-if="view == 'Promotions'" />
      <Gift v-if="view == 'Gift'" />
      <GiftReport v-if="view == 'GiftReport'" />
      <RedeemCode v-if="view == 'RedeemCode'" />
      <!-- <ExtraService v-if="view == 'ExtraService'" /> -->

      <!-- </v-container> -->
    </div>
  </main-layout>
</template>

<script>
import Promotions from './Promotions'
import Gift from './Gift'
import GiftReport from './GiftReport'
import ExtraService from './ExtraService'
import RedeemCode from './RedeemCode'

export default {
  components: {
    Promotions,
    Gift,
    GiftReport,
    ExtraService,
    RedeemCode
  },
  data() {
    return {
      viewPage: 'promotions',
      menuItem: [
        {
          text: 'Promotions',
          view: 'Promotions'
        },
        {
          text: 'Gift',
          view: 'Gift'
        },
        {
          text: 'Gift Report',
          view: 'GiftReport'
        },
        {
          text: 'Redeem Code',
          view: 'RedeemCode'
        }
        // {
        //   text: 'Extra Service',
        //   view: 'ExtraService',
        // },
      ]
    }
  },

  computed: {
    filterdMenuItem() {
      return this.menuItem
    },
    view() {
      this.viewPage = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      var result = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      if (this.filterdMenuItem.some((el) => el.view == result)) {
        return result
      } else {
        return this.filterdMenuItem[0].view
      }
    }
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/main.vue